import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UserState {
  userData: any | null;
  isLoggedIn: boolean,
}

const initialState: UserState = {
  userData: null,
  isLoggedIn: false,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUserData: (state, action: PayloadAction<any>) => {
      state.userData = action.payload;
    },
    clearUserData: (state) => {
      state.userData = null;
    },
    setUserLoggedIn: (state) => {
      state.isLoggedIn = true;
      localStorage.setItem('isLoggedIn', 'true');
    },
    setUserLoggedOut: (state) => {
      state.isLoggedIn = false;
      localStorage.setItem('isLoggedIn', 'false');
    },
  },
});

export const { setUserData, clearUserData, setUserLoggedIn, setUserLoggedOut } = authSlice.actions; // Export new actions
export default authSlice.reducer;
